import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

    /* ================= DIALOG (KEEP FULL THEME) ================= */

    dialogContent: {
        flex: "1",
        backgroundColor: "#FFFFFF",
        maxWidth: "900px",
        minWidth: "900px"
    },

    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        padding: '0px 0px 15px 0px'
    },

    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '15px 10px',
        alignItems: 'baseline',
        backgroundColor: "#454545",
        cursor: 'move',
        justifyContent: 'space-between'
    },

    content: {
        flex: "1 1 auto",
        marginBottom: "10px",
        padding: '10px 20px'
    },

    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '0 20px',
        marginTop: '10px'
    },

    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },

    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },

    title: {
        fontFamily: 'Lato',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },

    backBtn: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#454545',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        border: '1px solid #454545',
        cursor: 'pointer',
    },

    changeBtn: {
        fontSize: '14px',
        fontWeight: 600,
        backgroundColor: '#454545',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            background: '#5e5e5e',
            color: '#ffffff',
        }
    },

    /* ================= FORM / FIELD STYLES (FROM EARLIER) ================= */

    labelText: {
        fontFamily: 'Lato',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "14px 0px 5px",
    },

    imageUploadContainer: {
        border: '1px dashed #454545',
        minHeight: '140px',
        borderRadius: '5px',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        flexFlow: 'column',
        cursor: 'pointer',
        background: '#fafafa',

        "& p": {
            color: '#6f6f6f',
            fontSize: '13px',
        }
    },

    inputFile: {
        border: '1px solid #d0d0d0',
        borderRadius: '4px',
        padding: '3px 5px',
        background: '#ffffff',
    },

    /* Optional: cleaner spacing for fields */
    marginTopTwenty: {
        marginTop: '25px',
    }

}));